import { defineMessages } from 'react-intl';

export const messages: {
	aIAttributionLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	aIDisclaimer: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	aIDisclaimer: {
		id: 'company-hub.company-hub-common.link-cards.description.ai-disclaimer',
		defaultMessage: 'Content quality may vary',
		description:
			'Text that shows AI disclaimer when user generates description using AI in the link cards config panel',
	},
	aIAttributionLabel: {
		id: 'company-hub.company-hub-common.link-cards.description.link.label.ai',
		defaultMessage: 'Learn more about Atlassian AI',
		description: 'Link label to learn more about Atlassian AI',
	},
});
